import { actionTypes } from '@/core/constants'
import { DownloadFile, UploadFile } from '@/core/utils'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ARQUIVO.ENVIAR_ARQUIVO_TEMPORARIO](context, arquivo) {
		const formData = UploadFile.createFormData(arquivo)
		const { data } = await api.arquivoTemporario.enviarTemporario(formData)
		return data
	},

	async [actionTypes.ARQUIVO.EXCLUIR_ARQUIVO_TEMPORARIO](context, idExterno) {
		await api.arquivoTemporario.excluirTemporario(idExterno)
	},

	async [actionTypes.ARQUIVO.BAIXAR_ARQUIVO_TEMPORARIO](context, idExterno) {
		const response = await api.arquivoTemporario.baixarTemporario(idExterno)
		const headers = response.headers
		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
}
